import { ESIGNATURE_TYPE } from '../../../redux/actions/rootAction';
import { WEBSOCKET_TOPICS } from '../../../redux/middleware/webSocket';
import PaperflyAPI from '../../../server/api/PaperflyAPI';
import {
  openAtrustPopupWin,
  openSignMePopupWin,
  openYesPopupWin,
  redirectExternalPopUp
} from './utils';

/** Shared QES step ids used by provider modals */
export const QES_STEP_ID = {
  CREATE_REQUEST: 'create_request',
  PREPARE_DOCUMENT: 'prepare_document',
  CHECK_REGISTRATION: 'check_registration',
  COMPLETE_REGISTRATION: 'complete_registration',
  COMPLETE_SIGNING: 'complete_signing',
  SIGNED_SUCCESS: 'signed_success'
};

export const QES_PROVIDER_DISPLAY = {
  [ESIGNATURE_TYPE.ATRUST]: 'A-Trust',
  [ESIGNATURE_TYPE.SIGNME]: 'sign-me',
  [ESIGNATURE_TYPE.YES]: 'YES'
};

const atrust = {
  type: ESIGNATURE_TYPE.ATRUST,
  displayName: QES_PROVIDER_DISPLAY[ESIGNATURE_TYPE.ATRUST],
  wsTopic: WEBSOCKET_TOPICS.ATRUST_SINGING,
  nopopupMessageKey: 'atrust_settings_nopopup_message',
  openPopupWin: openAtrustPopupWin,
  getSignatureStatus: sid => PaperflyAPI.getAtrustSignatureStatus(sid),
  createSignatureProcess: (recipientRequestId, docs) =>
    PaperflyAPI.atrustCreateSignatureProcess(recipientRequestId, docs),
  submitToPopup: (winReference, url, purpose) =>
    redirectExternalPopUp(winReference, url, purpose || 'sign'),
  needsRegistrationUi: true
};

const signme = {
  type: ESIGNATURE_TYPE.SIGNME,
  displayName: QES_PROVIDER_DISPLAY[ESIGNATURE_TYPE.SIGNME],
  wsTopic: WEBSOCKET_TOPICS.SIGNME_SINGING,
  nopopupMessageKey: 'signme_settings_nopopup_message',
  openPopupWin: openSignMePopupWin,
  getSignatureStatus: sid => PaperflyAPI.getSignmeSignatureStatus(sid),
  createSignatureProcess: (recipientRequestId, documentIds, identityId) =>
    PaperflyAPI.signmeCreateSignatureProcess(
      recipientRequestId,
      documentIds,
      identityId
    ),
  submitToPopup: () => {
    const signmeForm = document.getElementById('signmeSignDocument');
    if (!signmeForm) return;
    if (signmeForm.requestSubmit) {
      signmeForm.requestSubmit();
    } else {
      signmeForm.submit();
    }
  },
  needsRegistrationUi: true
};

const yes = {
  type: ESIGNATURE_TYPE.YES,
  displayName: QES_PROVIDER_DISPLAY[ESIGNATURE_TYPE.YES],
  wsTopic: WEBSOCKET_TOPICS.YES_SINGING,
  nopopupMessageKey: 'yes_settings_nopopup_message',
  openPopupWin: openYesPopupWin,
  getSignatureStatus: sid => PaperflyAPI.getYesSignatureStatus(sid),
  createSignatureProcess: (recipientRequestId, docs) =>
    PaperflyAPI.yesCreateSignatureProcess(recipientRequestId, docs),
  submitToPopup: (winReference, url, purpose) =>
    redirectExternalPopUp(winReference, url, purpose || 'sign'),
  needsRegistrationUi: false
};

const registry = {
  [ESIGNATURE_TYPE.ATRUST]: atrust,
  [ESIGNATURE_TYPE.SIGNME]: signme,
  [ESIGNATURE_TYPE.YES]: yes
};

export function getQesProvider(type) {
  return registry[type] || null;
}

export {
  atrust as atrustProvider,
  signme as signmeProvider,
  yes as yesProvider
};
